import { makeStyles } from '@material-ui/core/styles'
import { Container, Button } from '@material-ui/core'
import { CONTACT_US } from '../../../routes'

const useStyles = makeStyles((theme) => ({
    bg: {
        background: '#005C58',
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'left',
        padding: '1rem .5rem 2rem 0.5rem',
        [theme.breakpoints.up('md')]: {
            padding: '4rem 0',
        },
    },
    textContainer: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'left',
        marginBottom: '1rem',
    },
    textContainerChild: {
        [theme.breakpoints.up('md')]: {
            width: '900px',
        },
    },
    title: {
        color: '#fff',
        fontWeight: '700',
        fontSize: '1.6rem',
        [theme.breakpoints.up('md')]: {
            fontSize: '2rem',
        },
    },
    p: {
        color: '#fff',
        [theme.breakpoints.up('md')]: {
            fontSize: '1.1rem',
        },
    },
    button: {
        borderRadius: '5px',
        fontWeight: '700',
        fontSize: '16px',
        padding: '12px 24px 12px 12px',
        border: `2px solid white`,
        color: 'white',
        backgroundColor: 'transparent',
        marginTop: '.5rem',
        display: 'block',
        textTransform: 'none',
        textAlign: 'center',
        width: '16rem',
        [theme.breakpoints.up('sm')]: {
            width: '20rem',
        },
        [theme.breakpoints.up('md')]: {
            marginTop: '3.5rem',
        },
        '&:hover': {
            backgroundColor: `#005C58!important`,
            color: `white!important`,
        },
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'left',
    },
}))

const HopeThisClearsUpSection = ({ baseUrl }) => {
    const classes = useStyles()

    return (
        <div className={classes.bg}>
            <Container>
                <h4 className={classes.title}>
                    We hope this clears things up!
                </h4>
                <div className={classes.textContainer}>
                    <div className={classes.textContainerChild}>
                        <p className={classes.p}>
                            We appreciate and respect the time you are taking to
                            look into our gift card company and protect
                            yourself. But rest assured Gift Card Granny is
                            committed to providing a safe and meaningful gifting
                            experience for every customer.
                        </p>
                        <p className={classes.p}>
                            If you have any questions, please do not hesitate to
                            reach out to our friendly Customer Service team.{' '}
                        </p>
                        <div className={classes.buttonContainer}>
                            <Button
                                href={baseUrl + CONTACT_US}
                                className={classes.button}
                            >
                                Let's Talk
                            </Button>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default HopeThisClearsUpSection
